export interface SamplePage {
  /** Full URL of a real interior page from the product. */
  image: string
  title: string
  caption: string
}

/** Real interior pages from the pack, shown in the sample carousel. */
export const samplePages: SamplePage[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/sNkLDEVfKt2NMiyQYG2fAA/01_portada.png',
    title: '50 ćwiczeń na gitarę jazzową',
    caption: 'Od poziomu początkującego do wyzwania — z czytelną legendą zapisu.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/3MzTgiXU8DxZbeUME8aGP7/02_dzwieki_przewodnie.png',
    title: 'Ćwiczenie 6 — Linia dźwięków przewodnich, ii–V–I w C',
    caption: 'Tabulatura z akordami, stopniami i liczeniem rytmu.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/urCjPkpPHCiCX76cU6993k/03_turnaround.png',
    title: 'Ćwiczenie 8 — Akompaniament turnaroundu I–VI–ii–V',
    caption: 'Rytm akompaniamentu i chwyty rozpisane akord po akordzie.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/hnVbVCeY4JqLbKHFuw9wzv/04_backdoor.png',
    title: 'Ćwiczenie 21 — Backdoor ii–V',
    caption: 'Wzorce i akompaniament ze stopniami każdego akordu.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/342jjWQHXayWP5Df7er65e/05_bebop_aaba.png',
    title: 'Ćwiczenia 41–42 — Linia bebopowa i forma AABA',
    caption: 'Poziom wyzwanie i materiał wzorcowy w jednym pakiecie.',
  },
]
